<template>
    <div class="flex items-center justify-center">
        <div class="relative text-lg">
            <button class="ml-1 flex justify-center items-center focus:outline-none"
                @click="isOptionsExpanded = !isOptionsExpanded" @blur="isOptionsExpanded = false">
                <Gravatar class="h-10 w-10 rounded-full object-cover" :email="JSON.parse($attrs.user).email" />


                <svg class="h-4 w-4 fill-current" :class="isOptionsExpanded ? 'rotate-180' : 'rotate-0'"
                    viewBox="0 0 192 512">
                    <path d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72
							72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72
							72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0
							352c0 39.8 32.2 72 72 72s72-32.2
							72-72-32.2-72-72-72-72 32.2-72 72z">
                    </path>
                </svg>

            </button>
            <transition enter-active-class="transform transition duration-500 ease-custom"
                enter-class="-translate-y-1/2 scale-y-0 opacity-0" enter-to-class="translate-y-0 scale-y-100 opacity-100"
                leave-active-class="transform transition duration-300 ease-custom"
                leave-class="translate-y-0 scale-y-100 opacity-100" leave-to-class="-translate-y-1/2 scale-y-0 opacity-0">
                <ul v-show="isOptionsExpanded"
                    class="absolute right-0 translate-y-2 mb-4 bg-white divide-y rounded-lg shadow-lg overflow-hidden">
                    <a class="dropdown-item text-muted w-full" href="../logout" onclick="event.preventDefault();
                                                document.getElementById('logout-form').submit();">
                        <li class="px-3 py-2 transition-colors duration-300 hover:bg-gray-200">
                            Logout
                        </li>
                    </a>
                </ul>
            </transition>
        </div>
    </div>
</template>
  
<script>

import Gravatar from 'vue-gravatar';

export default {
    components: {
        Gravatar,
    },
    data() {
        return {
            isOptionsExpanded: false,
        };
    },
};
</script>
  